(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bruce-dragon-fragrance-quiz"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('bruce-dragon-quiz')) return;

    var PRODUCT_META = {
      aura:     { name: 'AURA',      scentWords: ['Fresh', 'Citrus'], personalityWords: ['Bold', 'Unforgettable'] },
      ultimate: { name: 'ULTIMATE',  scentWords: ['Woody'],           personalityWords: ['Fresh', 'Clean'] },
      radiate:  { name: 'RADIATE',   scentWords: ['Fruity'],          personalityWords: ['Confident', 'Energetic'] },
      newFlora: { name: 'NEW FLORA', scentWords: ['Floral'],          personalityWords: ['Elegant', 'Attractive'] },
      blaze:    { name: 'BLAZE',     scentWords: ['Woody'],           personalityWords: ['Bold', 'Unforgettable'] },
      breeze:   { name: 'BREEZE',    scentWords: ['Fruity'],          personalityWords: ['Fresh', 'Clean'] },
      cigar:    { name: 'CIGAR',     scentWords: ['Floral', 'Woody'], personalityWords: ['Confident', 'Energetic'] },
      escape:   { name: 'ESCAPE',    scentWords: ['Floral'],          personalityWords: ['Elegant', 'Attractive'] }
    };

    var PRODUCT_KEYS = ['aura', 'ultimate', 'radiate', 'newFlora', 'blaze', 'breeze', 'cigar', 'escape'];

    var QUESTIONS = [
      { id: 'q1', title: 'What kind of fragrance do you like?', options: [
        { id: 'a', label: 'Fresh & Citrus', scores: { aura: 5, ultimate: 0, radiate: 0, newFlora: 0, blaze: 0, breeze: 0, cigar: 0, escape: 0 } },
        { id: 'b', label: 'Fruity',         scores: { aura: 0, ultimate: 0, radiate: 5, newFlora: 0, blaze: 0, breeze: 5, cigar: 0, escape: 0 } },
        { id: 'c', label: 'Floral',         scores: { aura: 0, ultimate: 0, radiate: 0, newFlora: 5, blaze: 0, breeze: 0, cigar: 5, escape: 5 } },
        { id: 'd', label: 'Woody',          scores: { aura: 0, ultimate: 5, radiate: 0, newFlora: 0, blaze: 5, breeze: 0, cigar: 5, escape: 0 } }
      ] },
      // Strict per Arun's authoritative mapping (Aug 2026): Aura=citrus,
      // Radiate/Breeze=fruity, NewFlora/Cigar/Escape=floral,
      // Ultimate/Blaze/Cigar=woody. No cross-category partial credit —
      // see rankAndPickWinner's Q1 gate below for why that matters.
      { id: 'q2', title: 'When would you wear it?', options: [
        { id: 'a', label: 'Everyday',         scores: { aura: 3, ultimate: 5, radiate: 3, newFlora: 0, blaze: 5, breeze: 3, cigar: 3, escape: 0 } },
        { id: 'b', label: 'Day Out',          scores: { aura: 3, ultimate: 3, radiate: 5, newFlora: 3, blaze: 3, breeze: 5, cigar: 0, escape: 3 } },
        { id: 'c', label: 'Date Night',       scores: { aura: 0, ultimate: 3, radiate: 3, newFlora: 3, blaze: 3, breeze: 3, cigar: 5, escape: 5 } },
        { id: 'd', label: 'Special Occasion', scores: { aura: 0, ultimate: 0, radiate: 0, newFlora: 5, blaze: 0, breeze: 0, cigar: 0, escape: 3 } }
      ] },
      { id: 'q3', title: 'How do you want to smell?', options: [
        { id: 'a', label: 'Fresh & Clean',         scores: { aura: 0, ultimate: 5, radiate: 3, newFlora: 0, blaze: 3, breeze: 5, cigar: 0, escape: 0 } },
        { id: 'b', label: 'Confident & Energetic', scores: { aura: 3, ultimate: 3, radiate: 5, newFlora: 0, blaze: 3, breeze: 3, cigar: 5, escape: 3 } },
        { id: 'c', label: 'Elegant & Attractive',  scores: { aura: 0, ultimate: 3, radiate: 3, newFlora: 5, blaze: 0, breeze: 0, cigar: 0, escape: 5 } },
        { id: 'd', label: 'Bold & Unforgettable',  scores: { aura: 5, ultimate: 0, radiate: 0, newFlora: 3, blaze: 5, breeze: 0, cigar: 3, escape: 3 } }
      ] }
    ];

    var MAX_POSSIBLE_SCORE = 15;
    var FINAL_FALLBACK_ORDER = ['aura', 'radiate', 'newFlora', 'ultimate', 'cigar', 'escape', 'breeze', 'blaze'];

    function findOption(question, answerId) {
      for (var i = 0; i < question.options.length; i++) {
        if (question.options[i].id === answerId) return question.options[i];
      }
      return null;
    }

    function scoreAnswers(answers) {
      var perQuestion = QUESTIONS.map(function (q) {
        var opt = findOption(q, answers[q.id]);
        var scores = {};
        PRODUCT_KEYS.forEach(function (k) { scores[k] = opt ? (opt.scores[k] || 0) : 0; });
        return scores;
      });
      var total = {};
      PRODUCT_KEYS.forEach(function (k) {
        total[k] = perQuestion.reduce(function (sum, qs) { return sum + qs[k]; }, 0);
      });
      return { total: total, perQuestion: perQuestion };
    }

    function primaryMatchCount(key, perQuestion) {
      return perQuestion.reduce(function (count, qs) { return count + (qs[key] === 5 ? 1 : 0); }, 0);
    }

    function rankAndPickWinner(scores, availability) {
      availability = availability || {};
      var total = scores.total;
      var perQuestion = scores.perQuestion;
      var candidates = PRODUCT_KEYS.slice();

      // Gate on Q1: only products that actually match the customer's
      // stated scent-family answer are eligible. Q2/Q3 rank within that
      // set but can never pull in an outside-the-family product, even
      // if they score very high there. Fixes: Fruity answers resolving
      // to New Flora (Floral) when Special Occasion + Elegant/Attractive
      // outweighed a correct-but-not-dominant Q1 match.
      var q1Matches = candidates.filter(function (k) { return perQuestion[0][k] > 0; });
      if (q1Matches.length) {
        candidates = q1Matches;
      }

      var allZero = candidates.every(function (k) { return total[k] === 0; });
      if (allZero) {
        return { winner: FINAL_FALLBACK_ORDER[0], total: total, available: availability[FINAL_FALLBACK_ORDER[0]] !== false };
      }

      function pickWinner(pool) {
        var maxTotal = Math.max.apply(null, pool.map(function (k) { return total[k]; }));
        var afterTotal = pool.filter(function (k) { return total[k] === maxTotal; });
        if (afterTotal.length === 1) return afterTotal[0];

        var maxQ1 = Math.max.apply(null, afterTotal.map(function (k) { return perQuestion[0][k]; }));
        var afterQ1 = afterTotal.filter(function (k) { return perQuestion[0][k] === maxQ1; });
        if (afterQ1.length === 1) return afterQ1[0];

        var maxQ2 = Math.max.apply(null, afterQ1.map(function (k) { return perQuestion[1][k]; }));
        var afterQ2 = afterQ1.filter(function (k) { return perQuestion[1][k] === maxQ2; });
        if (afterQ2.length === 1) return afterQ2[0];

        var maxQ3 = Math.max.apply(null, afterQ2.map(function (k) { return perQuestion[2][k]; }));
        var afterQ3 = afterQ2.filter(function (k) { return perQuestion[2][k] === maxQ3; });
        if (afterQ3.length === 1) return afterQ3[0];

        var maxPrimary = Math.max.apply(null, afterQ3.map(function (k) { return primaryMatchCount(k, perQuestion); }));
        var afterPrimary = afterQ3.filter(function (k) { return primaryMatchCount(k, perQuestion) === maxPrimary; });
        if (afterPrimary.length === 1) return afterPrimary[0];

        for (var i = 0; i < FINAL_FALLBACK_ORDER.length; i++) {
          if (afterPrimary.indexOf(FINAL_FALLBACK_ORDER[i]) !== -1) return FINAL_FALLBACK_ORDER[i];
        }
        return afterPrimary[0];
      }

      var remaining = candidates.slice();
      var winner = null;
      while (remaining.length && !winner) {
        var candidate = pickWinner(remaining);
        if (availability[candidate] !== false) {
          winner = candidate;
        } else {
          remaining = remaining.filter(function (k) { return k !== candidate; });
        }
      }
      if (!winner) winner = pickWinner(candidates);

      return { winner: winner, total: total, available: availability[winner] !== false };
    }

    function buildPersonalityLine(key) {
      var meta = PRODUCT_META[key];
      return meta.scentWords.concat(meta.personalityWords).join(' \u2022 ');
    }

    function buildExplanation(key, answers) {
      var meta = PRODUCT_META[key];
      var q1Label = findOption(QUESTIONS[0], answers.q1) ? findOption(QUESTIONS[0], answers.q1).label : '';
      var q2Label = findOption(QUESTIONS[1], answers.q2) ? findOption(QUESTIONS[1], answers.q2).label : '';
      var q3Label = findOption(QUESTIONS[2], answers.q3) ? findOption(QUESTIONS[2], answers.q3).label : '';
      var scentJoined = meta.scentWords.join(' and ').toLowerCase();
      var personalityJoined = meta.personalityWords.join(' and ').toLowerCase();
      var article = /^[aeiou]/.test(personalityJoined) ? 'an' : 'a';
      return 'Your answers point to ' + meta.name + '. You\u2019re drawn to ' + q1Label + ' scents, want something for ' + q2Label + ', and hope to feel ' + q3Label + '. ' + meta.name + ' matches that \u2014 ' + scentJoined + ' in character, with ' + article + ' ' + personalityJoined + ' edge.';
    }

    function track(eventName, detail) {
      try {
        document.dispatchEvent(new CustomEvent('bd_quiz:' + eventName, { detail: detail, bubbles: true }));
      } catch (e) { /* no-op */ }
      try {
        if (typeof window.gtag === 'function') {
          window.gtag('event', eventName, detail || {});
        }
      } catch (e) { /* no-op */ }
      try {
        if (typeof window.fbq === 'function') {
          window.fbq('trackCustom', eventName, detail || {});
        }
      } catch (e) { /* no-op */ }
    }

    function escapeHtml(str) {
      if (str == null) return '';
      return String(str).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }

    var BruceDragonQuiz = /** @class */ (function () {
      function BruceDragonQuiz(el) {
        this.el = el;
        var configEl = el.querySelector('script[data-quiz-config]');
        this.config = configEl ? JSON.parse(configEl.textContent) : { products: {} };
        this.answers = {};
        this.currentIndex = 0;
        this.screens = {
          intro: el.querySelector('[data-screen="intro"]'),
          question: el.querySelector('[data-screen="question"]'),
          result: el.querySelector('[data-screen="result"]')
        };
        this.bindStaticEvents();
      }

      BruceDragonQuiz.prototype.bindStaticEvents = function () {
        var self = this;
        var startBtn = this.el.querySelector('[data-action="start"]');
        if (startBtn) {
          startBtn.addEventListener('click', function () { self.start(); });
        }
        var backBtn = this.el.querySelector('[data-action="back"]');
        if (backBtn) {
          backBtn.addEventListener('click', function () { self.goBack(); });
        }
      };

      BruceDragonQuiz.prototype.start = function () {
        track('quiz_started', {});
        this.currentIndex = 0;
        this.answers = {};
        this.showScreen('question');
        this.renderQuestion();
      };

      BruceDragonQuiz.prototype.showScreen = function (name) {
        Object.keys(this.screens).forEach(function (key) {
          var node = this.screens[key];
          if (!node) return;
          node.hidden = key !== name;
        }, this);
      };

      BruceDragonQuiz.prototype.renderQuestion = function () {
        var q = QUESTIONS[this.currentIndex];
        var titleEl = this.screens.question.querySelector('[data-question-title]');
        var optionsEl = this.screens.question.querySelector('[data-options]');
        var progressLabel = this.screens.question.querySelector('[data-progress-label]');
        var progressFill = this.screens.question.querySelector('[data-progress-fill]');
        var progressBar = this.screens.question.querySelector('[data-progress-bar]');
        var backBtn = this.el.querySelector('[data-action="back"]');

        titleEl.textContent = q.title;
        optionsEl.innerHTML = '';
        optionsEl.setAttribute('aria-label', q.title);

        var selected = this.answers[q.id];

        q.options.forEach(function (opt) {
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'bd-quiz__option' + (selected === opt.id ? ' is-selected' : '');
          btn.textContent = opt.label;
          btn.setAttribute('data-option-id', opt.id);
          btn.setAttribute('aria-pressed', selected === opt.id ? 'true' : 'false');
          btn.addEventListener('click', this.selectOption.bind(this, q, opt));
          optionsEl.appendChild(btn);
        }, this);

        var progressPct = Math.round(((this.currentIndex) / QUESTIONS.length) * 100);
        progressLabel.textContent = (this.currentIndex + 1) + ' OF ' + QUESTIONS.length;
        progressFill.style.width = progressPct + '%';
        progressBar.setAttribute('aria-valuenow', String(progressPct));

        backBtn.hidden = this.currentIndex === 0;

        titleEl.focus({ preventScroll: true });
      };

      BruceDragonQuiz.prototype.selectOption = function (question, option) {
        this.answers[question.id] = option.id;
        track('quiz_question_answered', { question_id: question.id, answer_id: option.id });

        var self = this;
        window.setTimeout(function () {
          if (self.currentIndex < QUESTIONS.length - 1) {
            self.currentIndex += 1;
            self.renderQuestion();
          } else {
            self.finish();
          }
        }, 180);

        var optionsEl = this.screens.question.querySelector('[data-options]');
        Array.prototype.forEach.call(optionsEl.children, function (btn) {
          var isSel = btn.getAttribute('data-option-id') === option.id;
          btn.classList.toggle('is-selected', isSel);
          btn.setAttribute('aria-pressed', isSel ? 'true' : 'false');
        });
      };

      BruceDragonQuiz.prototype.goBack = function () {
        if (this.currentIndex === 0) return;
        this.currentIndex -= 1;
        this.renderQuestion();
      };

      BruceDragonQuiz.prototype.finish = function () {
        var availability = {};
        PRODUCT_KEYS.forEach(function (key) {
          var p = this.config.products[key];
          availability[key] = p ? !!p.available : false;
        }, this);

        var scores = scoreAnswers(this.answers);
        var result = rankAndPickWinner(scores, availability);
        this.lastResult = result;
        this.lastAnswers = Object.assign({}, this.answers);

        track('quiz_completed', { recommended_product: result.winner });

        this.renderResult(result);
        this.showScreen('result');

        this.screens.result.focus({ preventScroll: true });
      };

      BruceDragonQuiz.prototype.renderResult = function (result) {
        var self = this;
        var container = this.screens.result.querySelector('[data-result-content]');
        var key = result.winner;
        var meta = PRODUCT_META[key];
        var product = this.config.products[key] || {};

        var html = '';
        html += '<p class="bd-quiz__result-kicker">Your Bruce Dragon Signature Fragrance</p>';

        html += '<div class="bd-quiz__primary-card">';
        html += '<div class="bd-quiz__primary-image-wrap">';
        html += product.image
          ? '<img src="' + escapeHtml(product.image) + '" alt="' + escapeHtml(product.title || meta.name) + '" loading="lazy" width="900" height="900">'
          : '';
        html += '</div>';
        html += '<div>';
        html += '<h3 class="bd-quiz__primary-name">Bruce Dragon ' + escapeHtml(meta.name) + '</h3>';
        html += '<p class="bd-quiz__primary-desc">' + escapeHtml(buildExplanation(key, this.lastAnswers)) + '</p>';
        html += '<p class="bd-quiz__personality-line">' + escapeHtml(buildPersonalityLine(key)) + '</p>';

        if (product.price) {
          html += '<p class="bd-quiz__price-row"><span>' + escapeHtml(product.price) + '</span>';
          if (product.compareAtPrice) {
            html += '<span class="bd-quiz__price-compare">' + escapeHtml(product.compareAtPrice) + '</span>';
          }
          html += '</p>';
        }

        html += '<div class="bd-quiz__cta-row">';
        if (product.url) {
          if (result.available) {
            html += '<button type="button" class="button bd-quiz__cta-primary" data-add-to-cart data-product-key="' + key + '">SHOP ' + escapeHtml(meta.name) + '</button>';
          } else {
            html += '<a class="button bd-quiz__cta-primary" href="' + escapeHtml(product.url) + '">View ' + escapeHtml(meta.name) + '</a>';
          }
        }
        html += '</div>';
        if (!result.available) {
          html += '<p class="bd-quiz__unavailable-note">This fragrance is temporarily out of stock \u2014 tap through to be notified when it\u2019s back.</p>';
        }
        html += '</div>';
        html += '</div>';

        html += '<button type="button" class="bd-quiz__retake" data-action="retake">Retake Quiz</button>';

        container.innerHTML = html;

        var retakeBtn = container.querySelector('[data-action="retake"]');
        if (retakeBtn) retakeBtn.addEventListener('click', function () { self.retake(); });

        var cartBtn = container.querySelector('[data-add-to-cart]');
        if (cartBtn) cartBtn.addEventListener('click', function () { self.addToCart(cartBtn.getAttribute('data-product-key'), cartBtn); });
      };

      BruceDragonQuiz.prototype.addToCart = function (productKey, btn) {
        var self = this;
        var product = this.config.products[productKey];
        if (!product) return;

        track('quiz_shop_now_clicked', { product: productKey });

        if (!product.variantId || !this.config.cartAddUrl) {
          window.location.href = product.url;
          return;
        }

        btn.disabled = true;
        btn.classList.add('loading');
        btn.textContent = 'Adding\u2026';

        fetch(this.config.cartAddUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: product.variantId, quantity: 1 }] })
        })
          .then(function (res) {
            if (!res.ok) throw new Error('Add to cart failed');
            return res.json();
          })
          .then(function () {
            window.location.href = self.config.cartUrl || product.url;
          })
          .catch(function () {
            window.location.href = product.url;
          });
      };

      BruceDragonQuiz.prototype.retake = function () {
        track('quiz_started', { retake: true });
        this.answers = {};
        this.currentIndex = 0;
        this.showScreen('intro');
      };

      return BruceDragonQuiz;
    })();

    customElements.define('bruce-dragon-quiz', class extends HTMLElement {
      connectedCallback() {
        this.instance = new BruceDragonQuiz(this);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
